import { DownloadSecondItem } from '@/service/download.service'
import { Cascader } from 'antd-mobile'
import clsx from 'clsx'
import { FC, useMemo, useState } from 'react'
import Image from 'next/image'
import styles from './cascader.module.scss'
const MobileCascader: FC<{
  data: DownloadSecondItem[]
  secondTitle: string
  thirdTitle: string
  onSecondTitleChange: (title: string) => void
  onThirdTitleChange: (title: string) => void
}> = ({ data, secondTitle, thirdTitle, onSecondTitleChange, onThirdTitleChange }) => {
  const [visible, setVisible] = useState(false)
  const options = useMemo(
    () =>
      data.map((item) => ({
        label: item.title,
        value: item.title,
        children: item.items.map((item) => ({
          label: item.title,
          value: item.title,
        })),
      })),
    [data]
  )

  return (
    <div className={clsx('w-full bg-pdbg')}>
      <button
        className={clsx('w-full px-3 py-10px', 'flex items-center justify-between')}
        onClick={() => setVisible(true)}
      >
        <span className="text-14 text-black/90">
          {secondTitle} {thirdTitle && `- ${thirdTitle}`}
        </span>
        <div className="w-6 h-6 relative shrink-0">
          <Image src="/icons/icon_solid_arrow_down.svg" alt="" layout="fill" />
        </div>
      </button>
      <Cascader
        options={options}
        visible={visible}
        onClose={() => setVisible(false)}
        onConfirm={(value) => {
          if (!value.length) return
          onSecondTitleChange(value[0] as string)
          const defaultThirdTitle = options.find((item) => item.value === value[0])?.children?.[0]?.value
          onThirdTitleChange((value[1] as string) || (defaultThirdTitle as string))
        }}
        className={styles['cascader-container']}
      />
    </div>
  )
}

export default MobileCascader
